import './style.less';
import { POS_TYPES, INTEGRATION_STATUS } from '../../constants';

function IntegrationsController(Authentication, IntegrationService, $stateParams, $rootScope) {
  'ngInject';

  const ctrl = this;

  this.isStaging = __STAGING__;

  this.$onInit = async () => {
    ctrl.integrations = await IntegrationService.getAvailableIntegrations();
    ctrl.orgId = Authentication.user.org.id;

    setIntegrationsGroups();

    $rootScope.$on('integrations:updated', (event, integrations) => {
      ctrl.integrations = integrations;
      setIntegrationsGroups();
    });
  };

  function setIntegrationsGroups() {
    ctrl.posIntegrations = [];

    POS_TYPES.forEach((posItem) => {
      const integration = ctrl.integrations.find((i) => i.type === posItem);
      if (integration) {
        ctrl.posIntegrations.push(integration);
      }
    });

    ctrl.posIntegrations = buildIntegrations(ctrl.posIntegrations);
  }

  function buildIntegrations(integrations) {
    const newIntegrations = [];
    integrations.forEach((integration) => {
      if (
        integration.brands &&
        Object.keys(integration.brands).length &&
        integration.status === INTEGRATION_STATUS.DISABLED
      ) {
        Object.keys(integration.brands).forEach((brandName) => {
          const newInteg = { ...integration };
          newInteg.name = integration.brands[brandName].name;
          newInteg.type = `shift4_${brandName}`;
          newInteg.url = integration.brands[brandName].url;
          newInteg.icon = `/assets/integrations/${brandName
            .toLowerCase()
            .replace(/ /g, '_')}-icon.svg`;
          newIntegrations.push(newInteg);
        });
      } else {
        newIntegrations.push(integration);
      }
    });
    return newIntegrations;
  }

  this.shouldInstall = (integration) => $stateParams.type === integration.type;
}

export default {
  controller: IntegrationsController,
  controllerAs: 'ctrl',
  template: `
    <sling-loader class="integrations__loader" ng-if="!ctrl.integrations"></sling-loader>

    <h2 ng-show="ctrl.integrations" class="integrations__header">POS apps</h2>

    <integration-entry
      ng-repeat="integration in ctrl.posIntegrations"
      integration="integration"
      teaser="ctrl.integrationsTeasers[integration.type]"
      install="ctrl.shouldInstall(integration)"
    ></integration-entry>

  `,
};
